import React from 'react';
import { OfficialTableCell } from '../print/OfficialReportLayout';
import {
  RelatorioEmendaInstituicaoItem,
  RelatorioEmendaInstituicaoLinha,
} from '../../services/reportService';
import { fMoney } from '../../utils/emendaFormatters';
import { Table, Tbody, Tr } from '../ui/Table';

const isDevolvida = (status?: string) => /devolvid/i.test(status ?? '');

const codigoEmendaCurto = (item: RelatorioEmendaInstituicaoLinha) => {
  const codigo = item.codigoOficial?.trim();
  const exercicio = item.exercicio ? String(item.exercicio) : '';
  const numero = codigo?.split('-')[0]?.trim();
  if (numero && exercicio) return `${numero}/${exercicio}`;
  return codigo || 'Não informado';
};

interface ReportPorInstituicaoTableProps {
  data: RelatorioEmendaInstituicaoItem[];
  totalGeral: number;
}

const ReportPorInstituicaoTable: React.FC<ReportPorInstituicaoTableProps> = ({ data, totalGeral }) => {
  if (data.length === 0) {
    return (
      <div className="rounded-xl border border-slate-200 px-4 py-10 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
        Nenhuma emenda encontrada para os filtros informados.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {data.map((grupo, index) => (
        <section
          key={`${grupo.instituicaoId || 'sem'}-${index}`}
          className="overflow-hidden rounded-xl border border-slate-300 bg-white dark:border-slate-700 dark:bg-slate-900/80"
        >
          <div className="border-b border-slate-300 px-4 py-2 text-center text-sm font-bold uppercase tracking-wide text-slate-900 dark:border-slate-700 dark:text-slate-100">
            {grupo.instituicaoNome || 'Instituição não informada'}
          </div>
          <div className="overflow-x-auto">
            <Table>
              <Tbody>
                <Tr className="bg-slate-50 dark:bg-slate-800/80">
                  <OfficialTableCell head className="w-[30%]">Dotação:</OfficialTableCell>
                  <OfficialTableCell head colSpan={3}>{grupo.dotacaoOrcamentariaTexto || 'Não informada'}</OfficialTableCell>
                </Tr>
                <Tr className="bg-slate-100 dark:bg-slate-800">
                  <OfficialTableCell head>Parlamentar</OfficialTableCell>
                  <OfficialTableCell head>Nº Emenda</OfficialTableCell>
                  <OfficialTableCell head align="right">Valor</OfficialTableCell>
                  <OfficialTableCell head align="center">Código</OfficialTableCell>
                </Tr>
                {grupo.linhas.map((linha) => (
                  <Tr key={linha.id} className={isDevolvida(linha.statusCicloVida) ? 'border-l-4 border-red-400 bg-red-50 dark:bg-red-950/20' : ''}>
                    <OfficialTableCell>{linha.parlamentarNome || 'Não informado'}</OfficialTableCell>
                    <OfficialTableCell>{codigoEmendaCurto(linha)}</OfficialTableCell>
                    <OfficialTableCell align="right">{fMoney(linha.valor)}</OfficialTableCell>
                    <OfficialTableCell align="center">{linha.codigoOficial || 'Não informado'}</OfficialTableCell>
                  </Tr>
                ))}
                <Tr className="border-t-2 border-slate-300 bg-slate-50 dark:border-slate-700 dark:bg-slate-800/80">
                  <OfficialTableCell className="font-bold text-slate-800 dark:text-slate-100">Total</OfficialTableCell>
                  <OfficialTableCell />
                  <OfficialTableCell align="right" className="font-bold text-slate-800 dark:text-slate-100">{fMoney(grupo.total)}</OfficialTableCell>
                  <OfficialTableCell />
                </Tr>
              </Tbody>
            </Table>
          </div>
        </section>
      ))}
      <div className="flex items-center justify-between rounded-xl border border-slate-900 bg-slate-900 px-4 py-3 text-white dark:border-slate-700 dark:bg-slate-800">
        <span className="text-sm font-bold uppercase tracking-wide">
          Total geral - {new Set(data.map(g => g.instituicaoId || g.instituicaoNome)).size} instituição(ões)
        </span>
        <span className="text-base font-bold">{fMoney(totalGeral)}</span>
      </div>
    </div>
  );
};

export default ReportPorInstituicaoTable;
